import type { AccessPolicy, AccessPolicyUpdate } from "./_shared"

import { api } from "@/lib/api-client"

// Admin Groups Management
export type AdminGroupsResponse = {
  admin_groups: Record<string, AccessPolicy>
}

export async function getAdminGroups(): Promise<AdminGroupsResponse> {
  const response = await api.get("/admin/admin-groups")
  return response.data || response
}

export async function updateAdminGroupPolicy(
  groupKey: string,
  policy: AccessPolicyUpdate
): Promise<{ success: boolean; group_key: string; access: AccessPolicy }> {
  const response = await api.put(`/admin/admin-groups/${groupKey}`, policy)
  return response.data || response
}
